import React, { useEffect, useRef } from 'react';
import './App.css';
import cat from '../src/assets/cat.png'
import dog from '../src/assets/dog.png';
import fromicon from '../src/assets/form-icon.svg';
import { FaArrowRight, FaCheck } from 'react-icons/fa'; // Import icons at the top
import { FaHeartbeat } from 'react-icons/fa'; // Exemplo com React Icons (opcional)
import logo from '../src/assets/logo_multicare.svg';
import { FaPhoneAlt } from 'react-icons/fa'; 
import { BsSignStopFill } from "react-icons/bs";
import { IoIosInformationCircle } from "react-icons/io";
import { TiArrowUpOutline } from "react-icons/ti";
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FaIdCard } from 'react-icons/fa';  
import nameicon from '../src/assets/name.svg';
import phoneicon2 from '../src/assets/phone.svg';
import { IoPricetagsOutline } from "react-icons/io5";
import { useLocation } from 'react-router-dom';  // Certifique-se de importar useLocation

import zipicon from '../src/assets/zip.svg';
import nificon from '../src/assets/nif.svg';
import { MdEuroSymbol } from 'react-icons/md';  
import { FaUser } from 'react-icons/fa';  
import { FaEnvelope } from 'react-icons/fa';
import emailicon from '../src/assets/email.svg';
import arrowcta from '../src/assets/arrow-cta.svg';
import { useState } from 'react';
import Fidelidadepet from './Fidelidadepet';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Footer from './Footer';
import NotificationPopUp from './Notification';
import SecondVisitModal from './SecondVisitModal';
import BenefitsGrid from './BenefitsGrid';  
import Service from './Service';
import { lightGreen } from '@mui/material/colors';
import { FaCheckCircle, FaUserMd,  FaPercentage } from 'react-icons/fa';  
import PageNotFound from './PageNotFound'; // Componente 404


function App() {
  const [isSubmitting, setIsSubmitting] = useState(false); // Adicionar este estado
  const [countdown, setCountdown] = useState(15); 
  const targetUrl = 'https://www.fixo.pt/fixo/?utm_source=referral&utm_medium=afiliacao&utm_campaign=fid_pontual_fixo_referral_afiliacao_lp_pets_typ&utm_content=produto'; // URL de destino

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const [DivShowNameEmail, setDivShowNameEmail] = useState(0);


const nomeinp = useRef();
const emailinp = useRef();
const nifinp = useRef();
const zipinp = useRef();
const mobileinp = useRef();
  const [formstep, setFromstep] = useState(1);
 
  let sessionValue = sessionStorage.getItem('user_session');
  let sessionValueGuid = sessionStorage.getItem('user_sessionGuid');
  const getUUID = () => {
    if (crypto && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    } else {
      // Simple UUID generator (not cryptographically secure)
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
  };
  // Verifica e define `user_session`
  if (!sessionValue) {
    sessionValue = `session_${new Date().getTime()}`;  
    sessionStorage.setItem('user_session', sessionValue);  
  }

 
  useEffect(() => {
    // Extrair parâmetros da URL
    const queryParams = new URLSearchParams(window.location.search);
  
    // Obter os valores das query strings e converter para minúsculas
    let nameFromEmail = queryParams.get("NameFromEmail")?.toLowerCase() || "";
    let emailFromEmail = queryParams.get("emailFromEmail")?.toLowerCase() || "";
  
   
    // Definir valores padrão se for "name" ou "email"
    nameFromEmail = nameFromEmail === "name" ? "" : nameFromEmail;
    emailFromEmail = emailFromEmail === "email" ? "" : emailFromEmail;
 
    // Se existir `NameFromEmail`, atualiza o campo de nome
    if (nameFromEmail && nomeinp && nomeinp.current) {
      setFormdata((prevState) => ({ ...prevState, name: nameFromEmail }));
      nomeinp.current.value = nameFromEmail;  // Define valor no input de nome
    }
    if (!checkemailload(emailFromEmail)) {
      console.log("E-mail inválido.");
      return;
    }
  
  

  
    // Se existir `emailFromEmail` e ele for válido, atualiza o campo de e-mail
    if (emailFromEmail && emailinp && emailinp.current) {
      setFormdata((prevState) => ({ ...prevState, email: emailFromEmail }));
      emailinp.current.value = emailFromEmail;  // Define valor no input de e-mail
    }
  
    // Se ambos os campos estão preenchidos e válidos, avança para o passo 2
    if (nameFromEmail && emailFromEmail && nomeinp && nomeinp.current) {
      setFromstep(2);  // Define o próximo passo apenas se ambos os valores existirem
      document.getElementById('Txt2Step').innerHTML =
        nomeinp.current.value.split(" ")[0] + ", já está no último passo para solicitar a sua simulação.";
        setDivShowNameEmail(1);
        sendDataToGoogleSheet({
          fromwhere: "step1" ,
          name: nomeinp.current.value,
          email: emailinp.current.value,
        });
    }
  }, []);  // Dependências vazias para executar o useEffect apenas uma vez ao carregar a página
  
 
  
const [formdata, setFormdata] = useState(
  {
    pettype:'',
    agerange:'',
    petage:'',
    name:'',
email:'',
nif:'',
zip:'',
phone:''
  }
);

const marks = [
  
];
function valuetext(value) {
   return `${value}`;
}
const handleSliderChange = (event, newValue) => {
  let oldData={...formdata}
 
  setFormdata(oldData);
};

 
const [showMoreText, setShowMoreText] = useState(false); // State to control visibility

 

const validateform = (e) =>{
  let oldData={...formdata}
  let inp = e.target.name;
  let inpvalue =  e.target.value.slice(0, e.target.maxLength);
  if (inp === "nif" && inpvalue.length === 9) {
    zipinp.current.focus();
  }
 

  oldData[inp] =inpvalue;
    setFormdata(oldData);
}



const validatezip = (e) => {
  let value = e.target.value.replace(/ /g, "");  
  let inputNumbersOnly = value.replace(/\D/g, "");
  if (inputNumbersOnly.length > 8) {
    inputNumbersOnly = inputNumbersOnly.substr(0, 8);
  }
  const splits = inputNumbersOnly.match(/.{1,4}/g);
   let spacedNumber = "";
  if (splits) {
    spacedNumber = splits.join("-");
  }
  let oldData={...formdata}
  let inp = e.target.name;
  oldData[inp] =spacedNumber;
  if (value.length == 8) {
    mobileinp.current.focus();
  }
    setFormdata(oldData);
};
useEffect(()=>{

 
});
useEffect(() => {
  window.addEventListener('load', handleLoad, { once: true });

  return () => window.removeEventListener('load', handleLoad);
}, []);

const handleLoad = () => {
  sendDataToGoogleSheet({ fromwhere: "load" });
};

const checkempty = (inp) =>{
  if(inp.current.value == '')
    {
      inp.current.style.backgroundColor = "white"
      inp.current.classList.add("shadowinput");
      inp.current.focus();
      return false;
    }else{
      inp.current.classList.remove("shadowinput");
    return true;
    }
}

const checknumberonly = (inp) =>{
  if(!isNaN(inp.current.value))
    {
      inp.current.style.backgroundColor = "white"
      inp.current.classList.add("shadowinput");
      inp.current.focus();
      return false;
    }else{
      inp.current.classList.remove("shadowinput");
    return true;
    }
}



const checkemailload = (email) => {
  var emailregex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return emailregex.test(email);
};


const checkemail = (inp) =>{
  const errorMessage = document.getElementById('emaillbl'); 
  var emailregex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  if(!emailregex.test(inp.current.value))
    {
      errorMessage.textContent = 'Introduza um endereço de e-mail válido.'; 

      inp.current.style.backgroundColor = "white"
      inp.current.classList.add("shadowinput");
      inp.current.focus();
      return false;
    }else{
      errorMessage.textContent = ''; 
      inp.current.classList.remove("shadowinput");
    return true;
    }
}

const checkmobile = (inp, length) => {
  const errorMessage = document.getElementById('mobilelbl');
  let value = inp.current.value;
  value = value.replace(/\D/g, ''); // Remove non-digit characters
  let iserror = false;

  // Check if the number is 9 digits long and starts with allowed prefixes
  if (value.length === 9 && value[0] === '9' && ['1', '2', '3', '6'].includes(value[1])) {
    iserror = false;
    errorMessage.textContent = '';
  } else if (value.length === 9 && (value[0] !== '9' || !['1', '2', '3', '6'].includes(value[1]))) {
    errorMessage.textContent = '91, 92, 93 ou 96.';
    iserror = true;
  } else if (value.length < 9) {
    errorMessage.textContent = '9 dígitos.';
    iserror = true;
  }

  if (iserror) {
    inp.current.style.backgroundColor = "white";
    inp.current.classList.add("shadowinput");
    inp.current.focus();
    return false;
  } else {
    inp.current.classList.remove("shadowinput");
    return true;
  }
};


const checkpostalcode = (inp, length) =>{
  const errorMessage = document.getElementById("ziplbl");
  let iserror = false;
  if(inp.current.value.length != length)
    {
      errorMessage.textContent = 'O código postal deve ser exactamente 7 dígitos.';
      iserror = true;
    }else{
      iserror = false;
      errorMessage.textContent = '';
    }

  if(iserror)
    {
      inp.current.style.backgroundColor = "white"
      inp.current.classList.add("shadowinput");
      inp.current.focus();
      return false;
    }else{
      inp.current.classList.remove("shadowinput");
    return true;
    }
}


const checknif = (inp, length) => {
  const errorMessage = document.getElementById("niflbl");
  let iserror = false;
  const nif = inp.current.value;

  // Verifica o comprimento do NIF
  if (nif.length != length) {
    errorMessage.textContent = 'O NIF deve ter exatamente 9 dígitos.';
    iserror = true;
  } else if (!validateNIF(nif)) {
    // Se o comprimento está correto, valida o NIF com as regras adicionais
    errorMessage.textContent = 'O NIF fornecido é inválido.';
    iserror = true;
  } else {
    iserror = false;
    errorMessage.textContent = '';
  }

  if (iserror) {
    inp.current.style.backgroundColor = "white";
    inp.current.classList.add("shadowinput");
    inp.current.focus();
    return false;
  } else {
    inp.current.classList.remove("shadowinput");
    return true;
  }
}

// Função auxiliar para validar o NIF (integrada dentro do checknif)
function validateNIF(nif) {
  // Verifica se o primeiro ou os dois primeiros dígitos são válidos
  if (
    !['1', '2', '3', '5', '6', '8'].includes(nif.substr(0, 1)) &&
    !['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'].includes(nif.substr(0, 2))
  ) {
    return false;
  }

  // Cálculo do total com base nos primeiros 8 dígitos
  let total =
    nif[0] * 9 +
    nif[1] * 8 +
    nif[2] * 7 +
    nif[3] * 6 +
    nif[4] * 5 +
    nif[5] * 4 +
    nif[6] * 3 +
    nif[7] * 2;

  // Calcula o módulo 11
  let modulo11 = total - parseInt(total / 11) * 11;
  let comparador = modulo11 == 1 || modulo11 == 0 ? 0 : 11 - modulo11;

  // Verifica se o último dígito corresponde ao comparador
  return nif[8] == comparador;
}


const submitform = (step) => {

  if (!checkempty(nomeinp) ) {
    setFromstep(1)
    return;
  }
 
 
  if (!checkemail(emailinp) ) {
    setFromstep(1)
    return;
  }
 
  if (step == 1) {
    sendDataToGoogleSheet({
      fromwhere: "step1" ,
      name: nomeinp.current.value,
      email: emailinp.current.value,
    });
    setFromstep(2);
    document.getElementById('askproposal')?.scrollIntoView({ behavior: 'smooth' });
  }
  

  document.getElementById('Txt2Step').innerHTML = 
  nomeinp.current.value.split(" ")[0] + ", já está no último passo para solicitar a sua simulação.";


 
  
  if(formstep == 2){
if(
 checknif(nifinp, 9) == true
  && checkpostalcode(zipinp, 8) == true
  && checkmobile(mobileinp,9) == true
)
 {
  sendDataToGoogleSheet({
    fromwhere : "step3",
    name: nomeinp.current.value,
    email: emailinp.current.value,
    phone: mobileinp.current.value,
    vat: nifinp.current.value,
    postalCode: zipinp.current.value
  }); 

  senddata();

  const timer = setInterval(() => {
    setCountdown((prevCountdown) => {
      if (prevCountdown === 1) {
        window.location.href = targetUrl; // Redireciona após a contagem regressiva
        clearInterval(timer); // Para o timer após o redirecionamento
      }
      return prevCountdown - 1;
    });
  }, 1000);
  
     

}

  }
}




const senddata = async  () => {

  if (isSubmitting) return; // Bloqueia se já estiver enviando dados


  let sessionValueGuid = sessionStorage.getItem('user_sessionGuid');
  
  // Se a variável for nula ou indefinida, gere um novo GUID
  if (!sessionValueGuid) {
    sessionValueGuid = getUUID(); // Gera um novo GUID
    sessionStorage.setItem('user_sessionGuid', sessionValueGuid); // Salva no sessionStorage
  }

  // Se o nome for "Affiliate", dispara a lógica específica
  if (formdata.name.trim().toLowerCase() === "affiliate" || formdata.name.trim().toLowerCase().includes("test")) {
    setFromstep(3);
    const img = document.createElement("img");
    img.src = `https://emas.uinterbox.com/tracking/cnv?org=5634&evt=11103&cid=${sessionValueGuid }`;
    img.height = "1";
    img.width = "1";
    img.style.display = "none"; // Opcional: esconde a imagem
    document.body.appendChild(img);
    return;
  }


  const data = {
  nif: formdata.nif,
  name: formdata.name,
  email: formdata.email,
  phone: formdata.phone,
  zip: formdata.zip,
  argan: "",
  petname:"",
  licenseplate: "",
  observations: "",
  source: 469,
  scheduletype: 0,
  isClient: true,
  family: 0,
  uuid: sessionValueGuid,
  birthdate: "",
  date: new Date().toISOString()
  }
  const response = await fetch(
    //'https://localhost:7261/Leads/add', 
    'https://fidelidadeapi.quickflowai.com/Leads/add',
    {
    method: 'POST',
    body: JSON.stringify(data),  
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const result = await response.json();
 

// Se a variável for nula ou indefinida, gere um novo GUID
if (!sessionValueGuid) {
  sessionValueGuid = getUUID(); // Gera um novo GUID
  sessionStorage.setItem('user_sessionGuid', sessionValueGuid); // Salva no sessionStorage
}

 
   if(response.status == 200){
    setIsSubmitting(true);
    console.log("start");

    
    if (result.value == "Duplicate lead"){
      setFromstep(5)
    }else{
      const today = new Date();
      const day = today.getDay();
      if (day >= 1 && day <= 4){
        setFromstep(3)
        const img = document.createElement("img");
        img.src = `https://emas.uinterbox.com/tracking/cnv?org=5634&evt=11103&cid=${sessionValueGuid }`;
        img.height = "1";
        img.width = "1";
        img.style.display = "none"; // Opcional: esconde a imagem
        document.body.appendChild(img);

      }else{
        setFromstep(4)
        const img = document.createElement("img");
        img.src = `https://emas.uinterbox.com/tracking/cnv?org=5634&evt=11103&cid=${sessionValueGuid }`;
        img.height = "1";
        img.width = "1";
        img.style.display = "none"; // Opcional: esconde a imagem
        document.body.appendChild(img);
        
      }
    }

     }
}





function getSaudacao() {
  const now = new Date();
  const hour = now.getHours();

  if (hour >= 6 && hour < 13) {
    return "Bom dia";
  } else if (hour >= 13 && hour < 20) {
    return "Boa tarde";
  } else {
    return "Boa noite";
  }}


  
  const sendDataToGoogleSheet = async ({
    fromwhere ="",
    name = "",
    email = "",
    phone = "",
    vat = "",
    postalCode = "",
    observations = "N/A",
    petname= "N/A",
    petage = "N/A",
    publisher = "N/A"
  } = {}) => {
    // URL do Google Apps Script com CORS Anywhere como proxy
    const scriptUrl = 'https://script.google.com/macros/s/AKfycbzn-Mbyx3RixBni7507Zpsibl1dqJHC21Dlu9tPDg_TS0lk8p-q11gyvSPsqx4rIzfH/exec';
    const proxyUrl = 'https://corsproxy.io/?';

    

  
  
    let sessionValue = sessionStorage.getItem('user_session');
    let sessionValueGuid = sessionStorage.getItem('user_sessionGuid');
    
    // Verifica e define `user_session`
    if (!sessionValue) {
      sessionValue = `session_${new Date().getTime()}`;  
      sessionStorage.setItem('user_session', sessionValue);  
    }
    
    // Verifica e define `user_sessionGuid` (GUID)
    if (!sessionValueGuid) {
      sessionValueGuid = getUUID(); // Gera um GUID único
      sessionStorage.setItem('user_sessionGuid', sessionValueGuid); // Armazena o GUID no sessionStorage
    }
  
 
    const getGeoLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
    
        if (!response.ok) {
          throw new Error('Failed to fetch IP information');
        }
    
        const result = await response.json();
    
        // Use the correct field names returned by ipinfo.io
        if (result && result.country && result.region && result.city) {
          return `${result.country}, ${result.region}, ${result.city}`;
        } else {
          return 'Localização não encontrada';
        }
      } catch (error) {
        console.error('Erro ao obter geolocalização:', error);
        return 'Localização não encontrada';
      }
    };
    
  
    
    const getIPAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip; // Retorna o IP público
      } catch (error) {
        console.error('Erro ao obter o IP:', error);
        return 'IP Não Disponível';  
      }
    };

    const geoIp = await getGeoLocation();
    const userIP = await getIPAddress();

    // Definir valores padrão internos
    const data = {
      Campaign: 'Multicare',
      Session: sessionValue, 
      Date: new Date().toISOString(),  
      IP: userIP || 'N/A', 
      Device: navigator.userAgent.includes('Mobile') ? 'Mobile' : 'Desktop',  
      Geo_IP: geoIp,  
      Name: name, 
      Email: email,  
      Phone: phone,  
      Vat: vat,  
      PostalCode: postalCode,  
      Observations: observations,
      PetName:petname, 
      PetAge:petage, 
      Publisher: publisher ,
      UUID: sessionValueGuid 
    };
  
    try {
     
      const response = await fetch(proxyUrl + scriptUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      const result = await response.text();
      console.log(`Sucess ${result}`);
    } catch (error) {
      console.error(`Error ${error}`);
    }
  };
  

  
    const saudacao = getSaudacao();
  return (
    <>

{/* ===== NAVBAR ===== */}
<div className="navbar w-full p-4 lg:p-5 flex items-center justify-between fixed top-0 left-0 z-50">
  <img
    src={logo}
    alt="Multicare"
    className="h-[28px] lg:h-[36px] lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2"
  />
  <div className="ml-auto">
    <span className="navbar-price-badge">
      Desde <span className="price-value ml-1">17,14&euro;</span>/m&ecirc;s *
    </span>
  </div>
</div>

{/* ===== HERO + FORM ROW ===== */}
<div className="w-full flex flex-col lg:flex-row mt-[64px] relative bg-[rgb(239,171,0)] bg-no-repeat bg-cover bg-center lg:bg-fixed" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/fullscreen-banner-nao-cliente_DESKTOP_casal-usa-tablet.webp)` }}>
  <div className="absolute inset-0 bg-black/30 lg:bg-black/20 z-0"></div>

  {/* LEFT: Hero */}
  <div className="hero-section w-full lg:w-[55%] flex flex-col text-white min-h-[180px] lg:min-h-[600px] relative z-[1]">
    <div className="hero-content flex flex-col h-full px-5 lg:px-12 py-8 lg:py-16 justify-between">

      {/* Title */}
      <div className="mb-6">
        <h1 className="font-bebasneuepro text-4xl lg:text-6xl font-bold leading-tight" style={{ color: "#EFAB00" }}>
          SEGURO DE SA&Uacute;DE
        </h1>
        <span className="font-bebasneuepro text-2xl lg:text-3xl font-bold text-white">MULTICARE</span>
      </div>

    </div>
  </div>

  {/* RIGHT: Form */}
  <div className='w-full lg:w-[45%] lg:max-w-[480px] pb-16 lg:pb-24 px-4 lg:px-6 lg:mx-auto relative z-[1]' id="askproposal">

    {/* Form heading */}
    <div className={`text-center pt-5 pb-3 ${formstep > 2 ? 'hidden' : 'block'}`}>
      <span className="form-header-badge">
        <FaHeartbeat />
        {'\u00A0'}Solu&ccedil;&otilde;es que se adaptam &agrave; sua sa&uacute;de
      </span>
    </div>

    {/* Form card */}
    <div className={`form-card mx-2 ${formstep > 2 ? 'hidden' : 'block'}`}>

      {/* Step indicator */}
      <div className="form-step-indicator">
        <div className={`step-dot ${formstep === 1 ? 'active' : ''} ${formstep > 1 ? 'completed' : ''}`}>
          <span className="dot">{formstep > 1 ? <FaCheck size={12} /> : '1'}</span>
          <span className="hidden lg:inline">Dados</span>
        </div>
        <div className={`step-line ${formstep >= 2 ? 'active' : ''}`}></div>
        <div className={`step-dot ${formstep === 2 ? 'active' : ''}`}>
          <span className="dot">2</span>
          <span className="hidden lg:inline">Finalizar</span>
        </div>
      </div>

      {/* STEP 1 */}
      <div className={`px-5 lg:px-8 pb-4 ${formstep === 1 ? 'block' : 'hidden'}`}>
        <p className='font-bebasneuepro font-semibold text-center py-3 text-lg lg:text-xl text-[#333]'>
          {saudacao}, preencha os dados para pedir a sua simula&ccedil;&atilde;o.
        </p>

        <div className='form-input-group'>
          <FaUser className='input-icon' />
          <input type='text' ref={nomeinp} name="name" value={formdata.name} onChange={validateform} placeholder='O seu nome' maxLength={100} />
        </div>

        <div className='form-input-group'>
          <FaEnvelope className='input-icon' />
          <input type='email' ref={emailinp} name="email" value={formdata.email} onChange={validateform} placeholder='O seu email' maxLength={100} />
          <span id="emaillbl" className='error-label'></span>
        </div>

        <div className="py-2">
          <p className='text-xs text-[#888]'>
            <span onClick={() => setShowMoreText(!showMoreText)} className="terms-toggle">
              Ver termos e condi&ccedil;&otilde;es
              <span className={`chevron ${showMoreText ? 'open' : ''}`}>&#9660;</span>
            </span>
            {showMoreText && (
              <span className="block mt-3 text-[#666] leading-relaxed text-xs">
                Os dados pessoais por si acima facultados ser&atilde;o tratados <strong>para posterior contacto telef&oacute;nico com a finalidade de realizar a simula&ccedil;&atilde;o</strong> e para fazer o acompanhamento comercial da mesma, com fundamento no desenvolvimento de dilig&ecirc;ncias pr&eacute;-contratuais a pedido do titular e no interesse leg&iacute;timo do desenvolvimento da atividade comercial da Fidelidade.
                <a
                  href='https://www.fidelidade.pt/PT/protecao-dados/Documents/Politica_de_Privacidade_e_Protecao_de_Dados_Pessoais%E2%80%93FIDELIDADE.pdf'
                  className='block mt-2 underline text-themered text-xs'
                  target='_blank'
                  rel='noopener'
                >
                  Consulte aqui, informa&ccedil;&atilde;o mais detalhada sobre prote&ccedil;&atilde;o e tratamento dos seus dados pela Fidelidade.
                </a>
              </span>
            )}
          </p>
        </div>
      </div>

      {/* STEP 2 */}
      <div className={`px-5 lg:px-8 pb-4 ${formstep === 2 ? 'block' : 'hidden'}`}>
        <p className='font-bebasneuepro font-semibold text-center py-3 text-lg lg:text-xl text-[#333]' id="Txt2Step">Preencha o formul&aacute;rio</p>

        {DivShowNameEmail === 1 && (
          <>
            <div className='form-input-group'>
              <FaUser className='input-icon' />
              <input type='text' ref={nomeinp} name="name" value={formdata.name} onChange={validateform} placeholder='O seu nome' maxLength={100} />
            </div>
            <div className='form-input-group'>
              <FaEnvelope className='input-icon' />
              <input type='email' ref={emailinp} name="email" value={formdata.email} onChange={validateform} placeholder='Email' maxLength={100} />
              <span id="emaillbl" className='error-label'></span>
            </div>
          </>
        )}

        <div className='form-input-group'>
          <FaIdCard className='input-icon' />
          <input type='number' inputMode="numeric" ref={nifinp} name="nif" value={formdata.nif} onChange={validateform} placeholder='NIF' maxLength={9} />
          <span id="niflbl" className='error-label'></span>
        </div>

        <div className='flex flex-col lg:flex-row gap-0 lg:gap-3'>
          <div className='form-input-group w-full'>
            <FaMapMarkerAlt className='input-icon' />
            <input type='text' inputMode="numeric" ref={zipinp} name="zip" value={formdata.zip} onChange={validatezip} placeholder='C&oacute;digo Postal' maxLength={8} />
            <span id="ziplbl" className='error-label'></span>
          </div>
          <div className='form-input-group w-full'>
            <FaPhoneAlt className='input-icon' />
            <input type='number' inputMode="numeric" name="phone" ref={mobileinp} value={formdata.phone} onChange={validateform} placeholder='N&ordm; Telem&oacute;vel' maxLength={9} />
            <span id="mobilelbl" className='error-label'></span>
          </div>
        </div>
      </div>

      {/* FORM ACTIONS */}
      <div className="px-5 lg:px-8 pb-6 flex flex-col items-center gap-3">
        <div className="flex items-center gap-3 w-full justify-center">
          {formstep === 2 && (
            <button onClick={() => setFromstep(1)} className="form-back-btn">
              <FaArrowRight className="rotate-180" size={12} />
              Voltar
            </button>
          )}
          <button
            onClick={() => submitform(formstep)}
            disabled={isSubmitting}
            className={`form-cta-btn ${isSubmitting ? 'loading' : ''}`}
            role="button"
            aria-label={formstep === 1 ? 'Ir para o pr\u00F3ximo passo' : 'Solicitar simula\u00E7\u00E3o'}
          >
            {formstep === 1 ? (
              <>PR&Oacute;XIMO PASSO <FaArrowRight size={14} /></>
            ) : (
              <><FaCheck size={14} /> {isSubmitting ? 'A ENVIAR...' : 'PEDIR SIMULA\u00C7\u00C3O'}</>
            )}
          </button>
        </div>

        {/* Progress bar */}
        <div className="progress-bar-container w-full max-w-[350px]">
          <div className="progress-bar-track">
            <div className="progress-bar-fill" style={{ width: formstep === 1 ? '50%' : '100%' }}></div>
          </div>
        </div>
      </div>
    </div>

    {/* THANK YOU MESSAGES */}
    {[3, 4].includes(formstep) && (
      <div className="thankyou-message">
        <h3>Ol&aacute; {formdata["name"]}!</h3>
        <p>Obrigado pelo seu pedido de simula&ccedil;&atilde;o.</p>
        <p>Em breve, a nossa equipa entrar&aacute; em contacto consigo para lhe apresentar a nossa melhor proposta.</p>
        <p>Enquanto isso, explore mais em{' '}
          <a href='https://www.fixo.pt/fixo/?utm_source=referral&utm_medium=afiliacao&utm_campaign=fid_pontual_fixo_referral_afiliacao_lp_pets_typ&utm_content=produto' target='_blank' rel='noopener'>www.fixo.pt</a>
        </p>
        <p><strong>Fidelidade</strong></p>
      </div>
    )}

    {formstep === 5 && (
      <div className="thankyou-message">
        <h3>Obrigado {formdata["name"]}!</h3>
        <p>Verificamos que j&aacute; tinha pedido um contacto anteriormente.</p>
        <p>A nossa equipa entrar&aacute; em contacto consigo o mais breve poss&iacute;vel.</p>
        <p>Explore mais em{' '}
          <a href='https://www.fixo.pt/fixo/?utm_source=referral&utm_medium=afiliacao&utm_campaign=fid_pontual_fixo_referral_afiliacao_lp_pets_typ&utm_content=produto' target='_blank' rel='noopener'>www.fixo.pt</a>
        </p>
        <p><strong>Fidelidade</strong></p>
      </div>
    )}

    {formstep > 2 && (
      <div className="redirect-card mt-4">
        <div className="countdown">{countdown}</div>
        <p className="text-[#333] font-semibold text-base">
          Ser&aacute; redirecionado para{' '}
          <a href={targetUrl} className="text-[#EFAB00] font-bold underline">www.fixo.pt</a>
        </p>
      </div>
    )}

  </div>
</div>

{/* ===== FLOATING BENEFITS BAR (Multicare official style) ===== */}
<div className="bg-[#FFDD8C]">
<div className="relative z-10 max-w-[1100px] mx-auto px-4 -mt-8 lg:-mt-12 pb-0">
  <div className="bg-white px-6 py-8 lg:px-10 rounded-[24px] md:rounded-[32px] shadow-[4px_4px_30px_0px_rgba(0,0,0,0.15)] border border-[#F2F2F2]">
    <div className="flex flex-col xl:flex-row gap-8 xl:gap-14 xl:items-center">

      {/* Left: Text */}
      <div className="flex-shrink-0 lg:min-w-[300px]">
        <h6 className="text-[1.25rem] font-bold text-[#282A2A] leading-tight">Porqu&ecirc; escolher a Multicare?</h6>
        <p className="text-sm text-[#656769] mt-1 leading-tight">Veja as vantagens que temos para si.</p>
        <span
          className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-[#282A2A] underline decoration-[#A1A4A4] hover:decoration-[#FEC800] cursor-pointer group transition-colors"
          onClick={() => document.getElementById('askproposal')?.scrollIntoView({ behavior: 'smooth' })}
        >
          Pedir simula&ccedil;&atilde;o
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="inline"><path fillRule="evenodd" clipRule="evenodd" d="M2.833 7.5H12.5V8.5H2.833V7.5Z" fill="#3A3C3C" className="group-hover:fill-[#FEC800]" /><path fillRule="evenodd" clipRule="evenodd" d="M8 2.626L13.02 7.646a.5.5 0 010 .707L8 13.374l-.707-.707L11.96 8 7.293 3.333 8 2.626z" fill="#3A3C3C" className="group-hover:fill-[#FEC800]" /></svg>
        </span>
      </div>

      {/* Right: Benefit icons */}
      <div className="flex flex-wrap w-full gap-y-7 gap-x-0">
        {[
          { icon: <FaCheckCircle size={26} />, line1: 'Sem idade limite' },
          { icon: <FaUserMd size={26} />, line1: 'Consultas 24/7' },
          { icon: <FaHeartbeat size={26} />, line1: 'Rastreios gratuitos' },
          { icon: <FaPercentage size={26} />, line1: 'At\u00E9 15% fam\u00EDlias' },
        ].map((item, i) => (
          <div key={i} className="w-1/2 lg:w-1/4 px-2 flex gap-3 items-center">
            <div className="w-[48px] h-[48px] flex-shrink-0 rounded-full bg-[#FEC800] flex justify-center items-center">
              <span className="text-[#282A2A]">{React.cloneElement(item.icon, { size: 22 })}</span>
            </div>
            <div className="text-[0.9375rem] lg:text-[1rem] leading-snug font-medium text-[#656769]">
              {item.line1}
            </div>
          </div>
        ))}
      </div>

    </div>
  </div>
</div>

{/* ===== BENEFITS SECTION (same yellow bg, no gap) ===== */}
<div className="pt-6 pb-12 lg:pt-8 lg:pb-16">
  <div className="benefits-section-split" style={{ background: 'transparent', border: 'none', marginBottom: '32px' }}>
    <div className="benefits-split-inner">
      <div className="benefits-split-left">
        <div className="accent-line" style={{ background: '#EFAB00' }}></div>
        <h2 style={{ color: '#282A2A' }}>Multicare: vantagens diferenciadoras</h2>
      </div>
      <div className="benefits-split-right">
        <p style={{ color: '#656769' }}>Com a Multicare pode beneficiar de vantagens exclusivas e diferenciadoras, dependendo da solu&ccedil;&atilde;o contratada.</p>
      </div>
    </div>
  </div>

  <SecondVisitModal />
  <BenefitsGrid/>

  {/* CTA inside yellow section */}
  <div className="text-center pt-4 pb-4">
    <button
      className="inline-flex items-center gap-2 bg-[#282A2A] hover:bg-[#3A3C3C] text-white font-bold py-4 px-8 rounded-2xl text-lg transition-all duration-300 hover:-translate-y-1 font-bebasneuepro"
      onClick={() => document.getElementById('askproposal')?.scrollIntoView({ behavior: 'smooth' })}
    >
      <TiArrowUpOutline size={22} />
      Pedir a sua simula&ccedil;&atilde;o
    </button>
  </div>
</div>
</div>{/* close bg-[#FFDD8C] wrapper */}

<NotificationPopUp />
<Footer />
    </>
  );
}

export default App;
